
import React from 'react'
import { bankOptions } from 'syncra-storybook/shared/utils'

interface OptionBankIconProps {
  name: string
  className?: string
}

export const OptionBankIcon = ({ name, className }: OptionBankIconProps) => {
  // Находим банк в bankOptions по title (название из бэкенда)
  const bankEntry = Object.entries(bankOptions).find(
    ([_, bankData]) => bankData.title === name
  )

  // Если банка нет в bankOptions, возвращаем null
  if (!bankEntry) {
    return null
  }

  const bankIcon = bankEntry[1].icon

  // Оборачиваем иконку в контейнер с нужным размером
  return (
    <span className={className || 'w-5 h-5 inline-flex items-center justify-center'}>
      {React.cloneElement(bankIcon, { className: 'w-full h-full' })}
    </span>
  )
}
